import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const MetricsDisplayGridRowDataFragmentGql: DocumentNode = gql`
fragment MetricsDisplayGridRowDataFragment on Metric {
  ...MetricsDisplayGridRowDataFragmentWithoutPersonalSpace
  containerName
  containerType
}
${MetricsDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
